import { useMemo } from 'react';
import car from '~/assets/icons/car_2.svg';
import category from '~/assets/icons/category.svg';
import other from '~/assets/icons/other.svg';
import transactions from '~/assets/icons/transactions.svg';
import { ScrollContainer } from '~/components/ui/ScrollContainer';
import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import { BankTransactionCategory } from '~/shared';
import bank from '../../assets/images/bank_icon.svg';
import { SectionHeading } from '../SectionHeading';
import { Transaction } from '../Transaction';
import {
	StyledCategoriesContainer,
	StyledCategoriesList,
	StyledCategory,
	StyledContainer,
	StyledTransactionsContainer,
	StyledTransactionsList,
} from './Transactions.styled';

const Transactions: React.FC = () => {
	const transactionsList = useObservable(rage.bank.getTransactionHistory());

	const categoriesSpent = useMemo(() => {
		const categories = {
			vehicle: 0,
			bank: 0,
			other: 0,
		};
		for (const transaction of transactionsList) {
			if (transaction.amount < 0) {
				if (transaction.category === BankTransactionCategory.VEHICLE) {
					categories.vehicle += Math.abs(transaction.amount);
				} else if (
					transaction.category === BankTransactionCategory.BANK ||
					transaction.category === BankTransactionCategory.TRANSFER
				) {
					categories.bank += Math.abs(transaction.amount);
				} else {
					categories.other += Math.abs(transaction.amount);
				}
			}
		}
		return categories;
	}, [transactionsList]);

	return (
		<StyledContainer>
			<StyledCategoriesContainer>
				<SectionHeading icon={category} text={'Категории трат'} />
				<StyledCategoriesList>
					<StyledCategory
						style={{
							backgroundColor: 'rgba(45, 112, 218, 0.5)',
							borderColor: 'rgba(45, 112, 218, 1)',
							boxShadow: '0px 4px 16px rgba(45, 112, 218, 0.25)',
						}}
					>
						<img src={car} />
						<Text>Авто</Text>
						<Text>{categoriesSpent.vehicle.toLocaleString('ru-RU')} ₽</Text>
					</StyledCategory>
					<StyledCategory
						style={{
							backgroundColor: 'rgba(216, 40, 40, 0.5)',
							borderColor: 'rgba(216, 40, 40, 1)',
							boxShadow: '0px 4px 16px rgba(216, 40, 40, 0.25)',
						}}
					>
						<img src={bank} />
						<Text>Банк</Text>
						<Text>{categoriesSpent.bank.toLocaleString('ru-RU')} ₽</Text>
					</StyledCategory>
					<StyledCategory
						style={{
							backgroundColor: 'rgba(255, 174, 0, 0.5)',
							borderColor: 'rgba(255, 174, 0, 1)',
							boxShadow: '0px 4px 16px rgba(255, 174, 0, 0.25)',
						}}
					>
						<img src={other} />
						<Text>Другое</Text>
						<Text>{categoriesSpent.other.toLocaleString('ru-RU')} ₽</Text>
					</StyledCategory>
				</StyledCategoriesList>
			</StyledCategoriesContainer>
			<StyledTransactionsContainer>
				<SectionHeading icon={transactions} text={'Ваши транзакции'} />
				<ScrollContainer height={609} scrollbarHeight={570} scrollbarRight={10}>
					<StyledTransactionsList>
						{transactionsList.map((transaction, index) => (
							<Transaction
								key={index}
								amount={transaction.amount}
								description={transaction.description}
								category={transaction.category}
								wallet={transaction.wallet}
							/>
						))}
					</StyledTransactionsList>
				</ScrollContainer>
			</StyledTransactionsContainer>
		</StyledContainer>
	);
};

export { Transactions };
